<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted(){
      console.log('%c Report bugs to: vignesh.r@quinbay.com, monisha.a@quinbay.com ', 'background: green; color: #ffffff; border-radius : 2px;');
  }
};
</script>

<style>
.vue-simple-drawer{
    background-color: white !important ;
}
.vue-simple-drawer.cover.closeable.right{
    background-color: white !important ;
}
#app {
  /* font-family: proxima-nova, -apple-system, BlinkMacSystemFont, "San Francisco", "Helvetica Neue", Helvetica, Ubuntu,
    Roboto, Noto, "Segoe UI", Arial, sans-serif; */
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
